"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOwnedTokenAccounts = void 0;
const spl_token_1 = require("@solana/spl-token");
const axios_1 = __importDefault(require("axios"));
const anchor_1 = require("@project-serum/anchor");
const consts_1 = require("../consts");
async function getOwnedTokenAccounts(mint, publicKey, program) {
    const tokenPubkey = await spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, publicKey);
    let [internalUsdc] = anchor_1.utils.publicKey.findProgramAddressSync([publicKey.toBuffer(), Buffer.from("internal_usdc")], consts_1.PROGRAM_ID_PUBKEY);
    const result = await axios_1.default.post(program.provider.connection.rpcEndpoint, [
        {
            jsonrpc: "2.0",
            id: "1",
            method: "getTokenAccountBalance",
            params: [
                tokenPubkey,
                {
                    commitment: program.provider.connection.commitment || "recent",
                },
            ],
        },
        {
            jsonrpc: "2.0",
            id: "1",
            method: "getTokenAccountBalance",
            params: [
                internalUsdc,
                {
                    commitment: program.provider.connection.commitment || "recent",
                },
            ],
        },
    ]);
    const tokenAccount = result.data[0];
    const initBalance = result.data[1];
    let parsedTokenAccounts = [null, null];
    if (tokenAccount.result?.value?.uiAmount) {
        parsedTokenAccounts[0] = {
            parsed: {
                data: { ...tokenAccount.result.value },
                amount: tokenAccount.result.value.uiAmount,
                mint,
                owner: publicKey,
            },
            publicKey: tokenPubkey,
        };
    }
    if (initBalance?.result?.value?.uiAmount) {
        parsedTokenAccounts[1] = {
            parsed: {
                data: { ...initBalance.result.value },
                amount: initBalance.result.value.uiAmount,
                mint,
                owner: publicKey,
            },
            publicKey: internalUsdc,
        };
    }
    return parsedTokenAccounts;
}
exports.getOwnedTokenAccounts = getOwnedTokenAccounts;
//# sourceMappingURL=getTokens.js.map